export type StatusInfo = {
  label: string;
  colorScheme: string;
  tagLabel: string;
};

export const statusInfoMap: Record<string, StatusInfo> = {

  OPERATION_DENIED_DUE_TO_INTERNAL_POLICIES: {
    label: "Operação Negada",
    colorScheme: "#FF0000",
    tagLabel: "Operação negada por políticas internas.",
  },
  SUCCESS: {
    label: "Consulta Concluída",
    colorScheme: "#85c773",
    tagLabel: "Sucesso",
  },
  NO_BALANCE: {
    label: "Saldo Insuficiente",
    colorScheme: "#FF0000",
    tagLabel: "Cliente não possui saldo mínimo para realizar a antecipação.",
  },
  NO_ACCOUNT: {
    label: "Aviso Importante!",
    colorScheme: "#FF0000",
    // tagLabel: "Seu cliente não possui contas no FGTS. Peça para ele criar uma conta.",
    tagLabel: "Crie sua conta no FGTS",
  },
  PENDING: {
    label: "Aguardando Caixa",
    colorScheme: "yellow.400",
    tagLabel: "Aguardando",
  },
  INVALID_PERIOD: {
    label: "Aviso Importante!",
    colorScheme: "#FF0000",
    tagLabel: "Tente novamente, em 5 minutos.",
  },
  NOT_AUTHORIZED: {
    label: "Aviso Importante!",
    colorScheme: "#FF0000",
    tagLabel:
      "A CAIXA informou que não é possível realizar a consulta para o CPF informado.",
  },
  ONGOING_FIDUCIARY_OPERATION: {
    label: "Aviso Importante!",
    colorScheme: "#FF0000",
    tagLabel: "Existe uma operação em andamento para esse cliente. Confirme com ele.",
  },
  WORKER_NOT_ADHERED_TO_BIRTHDAY_WITHDRAWAL: {
    label: "Aviso Importante!",
    colorScheme: "#FF0000",
    // tagLabel:
    //   "Seu cliente voltou ao Saque Recisão. Confirme com ele, a modalidade correta deve ser Saque Aniversário.",
    tagLabel: "Seu cliente solicitou o retorno para a modalidade de Saque Rescisão. Peça para ele voltar à modalidade de Saque-Aniversário para seguir com a contratação. Tente novamente em 5 minutos.",
  },
  OPERATION_NOT_ALLOWED_BEFORE_DATE: {
    label: "Aviso Importante!",
    colorScheme: "#FF0000",
    // tagLabel:
    //   "Está próximo do aniversário do seu cliente. A operação não será permitida.",
    tagLabel: "Está próximo do aniversário do seu cliente. A operação não será permitida até a data"
  },
  OPERATION_NOT_ALLOWED_DUE_TO_PENDING_PAYMENT: {
    label: "Aviso Importante!",
    colorScheme: "#FF0000",
    tagLabel:
      "A CAIXA informa sobre uma pendência no pagamento do saque-aniversário. Por favor, peça ao seu cliente que se dirija a uma agência da CAIXA.",
  },
  WORKER_MUST_CANCEL_RETURN_REQUEST: {
    label: "Aviso Importante!",
    colorScheme: "#FF0000",
    // tagLabel:
    //   "Seu cliente solicitou o retorno para a modalidade de Saque Rescisão. Peça para ele voltar à modalidade de Saque-Aniversário para seguir com a contratação. Tente novamente em 5 minutos.",
    tagLabel: "Cliente não autorizou a modalidade de saque-aniversário. Confirme com ele."
  },
  ACCOUNT_CHANGES_PREVENT_CONTRACT: {
    label: "Aviso Importante!",
    colorScheme: "#FF0000",
    tagLabel:
      "A CAIXA informa que foram realizadas mudanças cadastrais na conta do FGTS, o que impede a contratação. Entre em contato com a CAIXA para regularização.",
  },
  FIDUCIARY_INSTITUTION_NO_VALID_AGREEMENT: {
    label: "Aviso Importante!",
    colorScheme: "#FF0000",
    tagLabel: "Banco sem autorização. Favor contatar o suporte.",
  },
  FIDUCIARY_INSTITUTION_NO_AUTHORIZATION: {
    label: "Aviso Importante!",
    colorScheme: "#FF0000",
    tagLabel:
      "Seu cliente ainda não autorizou a bancarizadora no aplicativo do FGTS. Você poderá realizar uma nova consulta em 5 minutos.",
  },
  UNEXPECTED_ERROR: {
    label: "Aviso Importante!",
    colorScheme: "#FF0000",
    tagLabel: "A CAIXA não teve sucesso na consulta. Consulte de novo em 5 minutos.",
  },
  CONSULTA_REALIZADA: {
    label: "Consulta Realizada",
    colorScheme: "#85c773",
    tagLabel: "A consulta foi processada com sucesso.",
  },
  MARGEM_INSUFICIENTE: {
    label: "Margem Insuficiente",
    colorScheme: "#FF0000",
    tagLabel: "O cliente não possui margem suficiente.",
  },
  AGUARDANDO_AUTORIZACAO_DO_CLIENTE: {
    label: "Aguardando Cliente Autorizar",
    colorScheme: "yellow.400",
    tagLabel: "Aguardando o cliente autorizar a consulta.",
  },
  EM_PROCESSAMENTO: {
    label: "Em Processamento",
    colorScheme: "yellow.400",
    tagLabel: "Consulta pendente de processamento.",
  },
  CONCLUIDO: {
    label: "Consulta Concluída",
    colorScheme: "#85c773",
    tagLabel: "Sucesso",
  },
  PROPOSTA_DIGITADA: {
    label: "Proposta Digitada",
    colorScheme: "#85c773",
    tagLabel: "Proposta digitada.",
  },
  SEM_MARGEM_DISPONIVEL: {
    label: "Sem Margem Disponível",
    colorScheme: "#FF0000",
    tagLabel: "Margem disponível já utilizada.",
  },
  ERRO_INESPERADO: {
    label: "Aviso Importante",
    colorScheme: "#FF0000",
    tagLabel: "Não obtivemos sucesso na consulta. Tente novamente em 5 minutos.",
  },
  NENHUM_EMPREGADOR_ELEGIVEL: {
    label: "Nenhum Empregador Elegível",
    colorScheme: "#FF0000",
    tagLabel: "Nenhum empregador elegível foi encontrado.",
  },
  PENDENTE_PROCESSAMENTO_BATCH: {
    label: "Pendente de Processamento",
    colorScheme: "yellow.400",
    tagLabel: "A consulta está pendente de processamento.",
  }
};

export function getStatusInfoFromApi(status?: string): StatusInfo {
  if (!status) {
    return {
      label: "Status não fornecido",
      colorScheme: "gray",
      tagLabel: "Não Fornecido",
    };
  }
  return (
    statusInfoMap[status] || {
      label: "Status desconhecido",
      colorScheme: "gray",
      tagLabel: "Desconhecido",
    }
  );
}
